/**
 * Permissions API Hooks
 * TanStack Query hooks for permissions domain
 */

import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api/client";

export interface Permission {
  id: string;
  resource: string;
  action: string;
  description?: string;
  createdAt?: string;
  updatedAt?: string;
}

export function usePermissions() {
  return useQuery({
    queryKey: ["permissions"],
    queryFn: async () => {
      const response = await api.permissions.list();
      // ✅ FIX: Garantir que sempre retornamos um objeto válido (nunca undefined)
      return { data: (response?.data ?? []) as Permission[] };
    },
    staleTime: 5 * 60 * 1000, // 5 minutos
    gcTime: 15 * 60 * 1000, // 15 minutos
    refetchOnWindowFocus: false,
    retry: 1,
  });
}

// getById not available for permissions API
// export function usePermission(id: string | null) {
//   return useQuery({
//     queryKey: ["permissions", id],
//     queryFn: async () => {
//       if (!id) return null;
//       const response = await api.permissions.getById(id);
//       return response.data as { data: Permission };
//     },
//     enabled: !!id,
//   });
// }

// useCheckPermission removido - endpoint /permissions/check não existe no backend
// Use useHasPermission() em src/hooks/use-permissions.ts que faz verificação local
// export function useCheckPermission(resource: string, action: string, companyId?: string, enabled = true) {
//   return useQuery({
//     queryKey: ["permissions", "check", resource, action, companyId],
//     queryFn: async () => {
//       const response = await api.permissions.check({ resource, action, companyId });
//       return response.data.hasPermission;
//     },
//     enabled: enabled && !!resource && !!action,
//     retry: false,
//   });
// }

export function useUserPermissions(companyId?: string) {
  return useQuery({
    queryKey: ["permissions", "user-permissions", companyId],
    queryFn: async () => {
      const response = await api.permissions.getUserPermissions({ companyId });
      // ✅ FIX: Garantir que sempre retornamos um valor válido (nunca undefined)
      return response.data ?? { permissions: [], roles: [] };
    },
    staleTime: 5 * 60 * 1000, // 5 minutos
    gcTime: 15 * 60 * 1000, // 15 minutos
    refetchOnWindowFocus: false,
    retry: 1,
  });
}

export function useCanAccessCompany(targetCompanyId: string | null, enabled = true) {
  return useQuery({
    queryKey: ["permissions", "can-access-company", targetCompanyId],
    queryFn: async () => {
      if (!targetCompanyId) return false;
      const response = await api.permissions.canAccessCompany(targetCompanyId);
      // ✅ FIX: Garantir que sempre retornamos um valor válido (nunca undefined)
      return response.data?.canAccess ?? false;
    },
    enabled: enabled && !!targetCompanyId,
    retry: false,
  });
}
